__turbopack_context__.v({
  "dot": "NowStatus-module__e7MezG__dot",
  "eyebrow": "NowStatus-module__e7MezG__eyebrow",
  "line": "NowStatus-module__e7MezG__line",
  "meta": "NowStatus-module__e7MezG__meta",
  "now": "NowStatus-module__e7MezG__now",
  "pill": "NowStatus-module__e7MezG__pill",
});
